import './Footer.scss';
import InputComponent from '../../common/InputComponent/InputComponent';
import DropdownComponent from '../../common/DropdownComponent/DropdownComponent';
import { Trans, useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { Divider } from 'antd';
import ButtonPrimaryMedium from '../../common/ButtonPrimary/ButtonPrimaryMedium';
import { useSelector } from 'react-redux';
import { CONST } from '../../../constants/constant';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import { Icon } from '../../icon/icon';
import ButtonLink from '../../common/ButtonLink/ButtonLink';
import { useNavigate } from 'react-router-dom';
import translateText from '../../../languages/translateText';
import SmartTranslate from '../../../languages/SmartTranslate';
import ROUTER from '../../../routers/Routers';
import { getValueFromString } from '../../../utils/data/getValue.utils';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { products } = useSelector(state => state.product);
  const navigate = useNavigate();

  return (
    <footer className="flex lg:py-[24px] lg:px-[80px] md:px-[20px] px-[16px] py-[32px] flex-col items-start lg:gap-[60px] gap-[32px] relative text-black/80 self-stretch bg-backgrounds-virtual">
      <div className="flex flex-col items-start gap-[24px] self-stretch">
        <div className="flex lg:flex-row flex-col items-start lg:gap-[40px] gap-[24px] self-stretch">
          <div className="flex flex-col items-start gap-[16px] grow self-stretch">
            <img
              src="/assets/logo/new_logo_fitta.png"
              alt=""
              className="h-[56px]"
            />
          </div>
          <Divider type="horizontal" className="m-0 !p-0 lg:hidden" />
          <div className="flex lg:flex-row flex-col items-start lg:gap-[40px] gap-[24px] self-stretch">
            <div className="flex w-[200px] flex-col items-start gap-[16px]">
              <span className="text-title-large !font-bold">
                {t('Shopping')}
              </span>
              <ul className="flex flex-col items-start gap-[8px]">
                {products.data?.map((item, index) => (
                  <li key={index} className="text-label-large">
                    <a
                      href={ROUTER.CATEGORY + '/' + item.id}
                      rel="noopener noreferrer"
                    >
                      {getValueFromString(item.name)}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <Divider type="horizontal" className="m-0 !p-0 lg:hidden" />
            <div className="flex w-[200px] flex-col items-start gap-[16px]">
              <span className="text-title-large !font-bold">
                {t('Support')}
              </span>
              <ul className="flex flex-col items-start gap-[8px]">
                <li className="text-label-large">
                  <a href={ROUTER.CENTER_SUPPORT}>{t('Support Center')}</a>
                </li>
                <li className="text-label-large">
                  <a href={ROUTER.CENTER_SUPPORT + ROUTER.WEB_APP_TERMS_OF_USE}>
                    {t('User Guide')}
                  </a>
                </li>
                <li className="text-label-large">
                  <a href={ROUTER.CENTER_SUPPORT + ROUTER.FAQ}>{t('FAQs')}</a>
                </li>
                <li className="text-label-large">
                  <a href={ROUTER.CENTER_SUPPORT + ROUTER.PRIVACY_POLICY}>
                    {t('Privacy policy')}
                  </a>
                </li>
              </ul>
            </div>
            <Divider type="horizontal" className="m-0 !p-0 lg:hidden" />
            <div className="flex w-[200px] flex-col items-start gap-[16px]">
              <span className="text-title-large !font-bold">
                {t('Contact us')}
              </span>
              <ul className="flex flex-col items-start gap-[8px]">
                <li className="text-label-large">
                  <a href={'tel:' + CONST.laNhaPhone.replace(/[^0-9+]/g, '')}>
                    {CONST.laNhaPhone}
                  </a>
                </li>
                <li className="text-label-large">
                  <a href={'mailto:' + CONST.laNhaEmail}>{CONST.laNhaEmail}</a>
                </li>
                <li className="text-label-large">
                  {t(
                    'Constant.50 9A Street, Trung Son Residential Area, Binh Chanh, Ho Chi Minh City, Vietnam'
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex  justify-between items-start gap-[24px] self-stretch">
          <div className="flex items-start gap-[16px]">
            <a
              target="_blank"
              href={CONST.laNhaFacebook}
              className="w-[24px] h-[24px]"
            >
              <Icon.ICFacebook />
            </a>
            <a
              target="_blank"
              href={CONST.laNhaIns}
              className="w-[24px] h-[24px]"
            >
              <Icon.ICInstagram />
            </a>
            <a
              target="_blank"
              className="w-[24px] h-[24px]"
              href={CONST.laNhaZalo}
            >
              <Icon.ICZalo />
            </a>
          </div>
          <div className="flex items-center gap-[8px] self-stretch">
            <span className="flex w-[34px] h-[24px]">
              <Icon.ICVisa />
            </span>
            <span className="flex w-[34px] h-[24px]">
              <Icon.ICMasterCard />
            </span>
            <span className="flex w-[34px] h-[24px]">
              <Icon.ICJCB />
            </span>
            <span className="flex w-[34px] h-[24px]">
              <Icon.ICAmex />
            </span>
            <span className="flex w-[34px] h-[24px]">
              <Icon.ICZaloPay />
            </span>
          </div>
        </div>
        <div className="flex lg:flex-row flex-col gap-[8px] justify-between lg:items-center items-start self-stretch">
          <span className="text-body-small">
            Công ty TNHH Thương Mại Dịch Vụ Fitta Số ĐKKD 0319478866 cấp lần đầu
            ngày 02/04/2026 tại Sở Tài Chính TPHCM
          </span>
          <span className="text-body-small">
            Copyright © 2026 Bản quyền thuộc về Fitta
          </span>
          <div className="flex items-center gap-[8px]">
            <ButtonLink
              title={t('Policy')}
              onClick={() => {
                navigate(ROUTER.CENTER_SUPPORT + '/terms-and-conditions');
              }}
            />
            <Divider type="vertical" style={{ height: '18px' }} />
            <ButtonLink
              title={t('Warranty')}
              onClick={() => {
                navigate(ROUTER.CENTER_SUPPORT + '/warranty-policy');
              }}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
